import { createContext, useContext, useEffect, useState, useCallback } from "react";
import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
const AuthContext = createContext(null);

export const useAuth = () => useContext(AuthContext);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null); // null=checking, false=none, obj=auth
  const [token, setToken] = useState(() => localStorage.getItem("ekg_token"));

  const authHeaders = useCallback(
    () => (token ? { Authorization: `Bearer ${token}` } : {}),
    [token],
  );

  const refresh = useCallback(async () => {
    if (!token) return;
    try {
      const { data } = await axios.get(`${API}/auth/me`, { headers: { Authorization: `Bearer ${token}` } });
      setUser(data);
    } catch {
      /* ignore */
    }
  }, [token]);

  useEffect(() => {
    const check = async () => {
      if (!token) return setUser(false);
      try {
        const { data } = await axios.get(`${API}/auth/me`, {
          headers: { Authorization: `Bearer ${token}` },
        });
        setUser(data);
      } catch {
        localStorage.removeItem("ekg_token");
        setToken(null);
        setUser(false);
      }
    };
    check();
  }, [token]);

  const login = async (email, password) => {
    const { data } = await axios.post(`${API}/auth/login`, { email, password });
    localStorage.setItem("ekg_token", data.access_token);
    setToken(data.access_token);
    // Re-fetch full profile
    const me = await axios.get(`${API}/auth/me`, { headers: { Authorization: `Bearer ${data.access_token}` } });
    setUser(me.data);
    return me.data;
  };

  const logout = () => {
    localStorage.removeItem("ekg_token");
    setToken(null);
    setUser(false);
  };

  return (
    <AuthContext.Provider value={{ user, admin: user, token, login, logout, refresh, authHeaders }}>
      {children}
    </AuthContext.Provider>
  );
}
